module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    class: _vm.isPc ? 'wrap-web' : 'wrap-phone',
    style: ({
      background: _vm.isPc ? 'url(' + _vm.bgImg + ') center center no-repeat' : '',
      'background-size': 'cover'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    attrs: {
      "isPc": _vm.isPc
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84452d62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/Wrap.vue
// module id = 790
// module chunks = 1